import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Box, Typography, Tabs, Tab, Button } from '@mui/material';
import ParticipantEntriesPage from './ParticipantEntriesPage';
import ParticipantProfilePage from './ParticipantProfilePage';
import ParticipantAnalyticsPage from './ParticipantAnalyticsPage';
import { getParticipantById } from '../api/contests';
import { RenderParticipantName, RenderParticipantPicture } from '../components/Elements';

const ParticipantMasterPage: React.FC = () => {
  const { participantId } = useParams<{ participantId: string }>();
  const [selectedTab, setSelectedTab] = useState(0);
  const [participantName, setParticipantName] = useState<string>('Участник');
  const [profilePicture, setProfilePicture] = useState<string | null>(null);
  const [rankTypes, setRankTypes] = useState<any[]>([]);
  const navigate = useNavigate();

  useEffect(() => {
    if (participantId) {
      getParticipantById(participantId)
        .then((data) => {
          setParticipantName(data?.name || 'Неизвестно');
          setProfilePicture(data?.profile_picture || null);
          const rows = Array.isArray(data?.ranks) ? data.ranks : [];
          setRankTypes(rows);
        })
        .catch((error) => console.error('Error fetching participant:', error));
    }
  }, [participantId]);

  const handleTabChange = (_event: React.SyntheticEvent, newValue: number) => {
    setSelectedTab(newValue);
  };

  return (
    <Box>
      <Box display="flex" alignItems="center" mb={3}>
        <Button variant="contained" color="primary" onClick={() => navigate(-1)} style={{ marginRight: '10px' }}>
          &lt;&lt;
        </Button>
        <Box sx={{ flexGrow: 1, minWidth: 0 }}>
          <Typography variant="h5" color="primary" noWrap>
            {RenderParticipantName(Number(participantId), participantName, profilePicture, true, rankTypes as any)}
          </Typography>
        </Box>
        {RenderParticipantPicture(Number(participantId), participantName, profilePicture, 60)}
      </Box>

      <Tabs value={selectedTab} onChange={handleTabChange} indicatorColor="primary" textColor="primary">
        <Tab label="Зарубы участника" />
        <Tab label="Аналитика" />
        <Tab label="Профиль участника" />
      </Tabs>

      {selectedTab === 0 && <ParticipantEntriesPage />}
      {selectedTab === 1 && <ParticipantAnalyticsPage participantId={participantId!} />}
      {selectedTab === 2 && <ParticipantProfilePage participantId={participantId!} />}
    </Box>
  );
};

export default ParticipantMasterPage;
